module.exports = __webpack_public_path__ + "static/img/closeFull.40f4ceb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/closeFull.svg
// module id = qLKN
// module chunks = 0